
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Eye, EyeOff, LoaderIcon } from "lucide-react";
import { useNavigate } from 'react-router-dom';
import React, { useState } from 'react';
import { toast } from "sonner";
import { Label } from "../ui/label";
import { apiClient } from "@/services/api";

const SignInForm = () => {

    const navigate = useNavigate();

    const [email, setEmail] = useState<string>("");
    const [password, setPassword] = useState<string>("");
    const [showPassword, setShowPassword] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const handleSignIn = async (e: React.FormEvent) => {
        e.preventDefault();

        if (!email || !password) {
            toast.error("Email e senha são obrigatórios!");
            return;
        }

        setIsLoading(true);

        try {
            const response = await apiClient.post<{ accessToken: string; refreshToken: string }>('/auth/login', { email, password });
            const { accessToken, refreshToken } = response;

            localStorage.setItem('accessToken', accessToken);
            localStorage.setItem('refreshToken', refreshToken);

            navigate("/dashboard");
        } catch (error: any) {
            const message = error?.response?.data?.message || error?.message;
            toast.error(message || "Erro ao fazer login. Tente novamente.");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="flex flex-col items-start gap-y-6 py-8 w-full px-0.5">
            <h2 className="text-2xl font-semibold">
                Entrar no MoovaTV
            </h2>

            <form onSubmit={handleSignIn} className="w-full">
                <div className="space-y-2 w-full">
                    <Label htmlFor="email">
                        Email
                    </Label>
                    <Input
                        id="email"
                        type="email"
                        value={email}
                        disabled={isLoading}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="Digite seu email"
                        className="w-full focus-visible:border-foreground"
                    />
                </div>
                <div className="mt-4 space-y-2">
                    <Label htmlFor="password">
                        Senha
                    </Label>
                    <div className="relative w-full">
                        <Input
                            id="password"
                            type={showPassword ? "text" : "password"}
                            value={password}
                            disabled={isLoading}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="Digite sua senha"
                            className="w-full focus-visible:border-foreground"
                        />
                        <Button
                            type="button"
                            size="icon"
                            variant="ghost"
                            disabled={isLoading}
                            className="absolute top-1 right-1"
                            onClick={() => setShowPassword(!showPassword)}
                        >
                            {showPassword ?
                                <EyeOff className="w-4 h-4" /> :
                                <Eye className="w-4 h-4" />
                            }
                        </Button>
                    </div>
                </div>
                <div className="mt-4 w-full">
                    <Button
                        type="submit"
                        disabled={isLoading}
                        className="w-full"
                    >
                        {isLoading ? (
                            <LoaderIcon className="w-5 h-5 animate-spin" />
                        ) : "Entrar"}
                    </Button>
                </div>

                <div className="mt-4 text-center">
                    <Button variant="link" className="text-sm text-muted-foreground hover:text-primary">
                        <a href="/auth/password-reset">Esqueceu sua senha?</a>
                    </Button>
                </div>
            </form>

            <div className="mt-6 text-center text-sm text-muted-foreground">
                <p>Não tem uma conta?</p>
                <Button variant="link" className="p-0 h-auto font-normal">
                    <a href="/auth/sign-up">Criar conta</a>
                </Button>
            </div>
        </div>
    )
};

export default SignInForm
